import Axios from 'axios'
import config from '../config'
import qs from 'qs'

export const search = async ({ codes, cityName, customerId, page = 0 }) => {
  const response = await Axios.get(
    `${config.baseURL}${config.apiURL}professionals/search`,
    {
      params: {
        zipCode: codes,
        size: config.paginate_size,
        page,
        customerId: customerId || undefined,
        cityName: cityName || undefined
      },
      paramsSerializer: (params) => {
        return qs.stringify(params, { indices: false } )
      }
    }
  )
  return response.data
}

export const get = async ({ externalId }) => {
  const url = `${config.baseURL}${config.apiURL}professionals/${externalId}`
  const response = await Axios.get(url)
  return response.data
}

/**
 * Fetch reviews from backend proxy (Skeepers API)
 * Expected response format:
 * {
 *   ratings: { average: 4.86, count: 7, distribution: { "5": 6, "4": 1, "3": 0, "2": 0, "1": 0 } },
 *   reviews: [{
 *     id, author, rate, content, date, verified,
 *     moderations: [{ comment, date, origin, origin_type: "merchant"|"moderator"|"consumer" }]
 *   }]
 * }
 */
export const getReviews = async ({ entityRelationId }) => {
  const url = `${config.baseURL}${config.apiURL}reviews/${entityRelationId}`
  const response = await Axios.get(url)
  return response.data
}

/**
 * Ratings displayed on the listing cards: { entityRelationId: { average, count } }.
 * The `id` the search returns for a professional IS the entityRelationId Skeepers is keyed on.
 * Professionals without reviews are simply absent from the map.
 * Chunked to keep the query string short, and time-boxed so a slow Skeepers never holds the listing.
 */
export const getBulkRatings = async ({ ids }) => {
  const chunks = []
  for (let i = 0; i < ids.length; i += config.ratings_bulk_chunk_size) {
    chunks.push(ids.slice(i, i + config.ratings_bulk_chunk_size))
  }

  const responses = await Promise.all(chunks.map(async (chunk) => {
    const response = await Axios.get(
      `${config.baseURL}${config.apiURL}reviews/ratings`,
      { params: { ids: chunk.join(',') }, timeout: config.ratings_timeout }
    )
    return response.data
  }))

  return responses.reduce((all, data) => Object.assign(all, data), {})
}

export const unavailability = async ({ secret, token }) => {
  const URL = `${config.baseURL}${config.apiURL}professionals/account/update-availability?secret=${secret}&token=${token}`
  const response = await Axios.get(URL)
  return {
    firstName: response.data.firstName || '',
    resetDate: response.data.nextResetDate
  }
}



// WEBPACK FOOTER //
// ./src/api/gardeners.js